import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { getGuid } from 'owa-guid';
import strings from 'owa-strings/owa-common-strings';
import { feedbackRibbonStore } from '../store/store';
import { setShowThankyouMessage } from '../mutators/setShowThankyouMessage';
import { logFeedbackRibbonClickResponse } from '../actions/logFeedbackRibbonClickResponse';

let styles = require('./FeedbackRibbon.scss');
export interface FeedbackRibbonProps {
    Feature: string;
    RibbonMessage: string;
    ThankYouMessage: string;
    SubFeature?: string;
    Metadata?: string;
    YesCallback?: () => void;
    NoCallBack?: () => void;
}

@observer
export default class FeedbackRibbon extends React.Component<FeedbackRibbonProps, {}> {
    sessionId: string;
    constructor(props: any) {
        super(props);
        this.sessionId = getGuid();
    }

    componentDidMount() {
        setShowThankyouMessage({
            showThankYouMessage: false,
        });
    }

    render() {
        return (
            <div>
                <div className={styles.RibbonMessage}>
                    {!feedbackRibbonStore().showThankYouMessage && (
                        <div>
                            <Icon iconName={ControlIcons.Help} className={styles.HelpIcon} />
                            {this.props.RibbonMessage}
                            <Link onClick={this.onYesClick} className={styles.YesLink}>
                                {strings.yesRibbonButtonText}
                            </Link>
                            <Link onClick={this.onNoClick} className={styles.NoLink}>
                                {strings.noRibbonButtonText}
                            </Link>
                        </div>
                    )}
                    {feedbackRibbonStore().showThankYouMessage && (
                        <div>{this.props.ThankYouMessage}</div>
                    )}
                </div>
            </div>
        );
    }

    private onYesClick = () => {
        logFeedbackRibbonClickResponse({
            SessionId: this.sessionId,
            Feature: this.props.Feature,
            RibbonResponse: 'Yes',
            Metadata: this.props.Metadata,
            SubFeature: this.props.SubFeature,
            clickCallback: this.props.YesCallback,
        });
    };

    private onNoClick = () => {
        logFeedbackRibbonClickResponse({
            SessionId: this.sessionId,
            Feature: this.props.Feature,
            RibbonResponse: 'No',
            Metadata: this.props.Metadata,
            SubFeature: this.props.SubFeature,
            clickCallback: this.props.NoCallBack,
        });
    };
}
